import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { AppErrorBoundary } from './components/AppErrorBoundary.tsx';
import { installChunkRecovery } from './app-recovery.ts';
import './styles/global.css';

// A tab running an old build after a deploy reloads once instead of going black (see app-recovery.ts)
installChunkRecovery();

const rootEl = document.getElementById('root');
if (rootEl) {
  createRoot(rootEl).render(
    <StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </StrictMode>,
  );
}
